"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const keys_1 = require("../wallet/keys");
function useEphemeralKey() {
    const [keyPair] = react_1.useState(keys_1.ephemeral);
    return keyPair;
}
exports.useEphemeralKey = useEphemeralKey;
//# sourceMappingURL=useEphemeralKeyHook.js.map